// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"431":"7ea852b8","453":"6ee1d859"}[chunkId] + ".chunk.js";
};